const STATUS = {
  COMPLETE: 1,
  CANCEL: 99
}

const STATUS_HISTORY_LABEL = {
  COMPLETE: 'order.order_complete',
  CANCEL: 'order.order_invalid'
}

// ステータス履歴表示用に作成必要とのこと
const STATUS_FOR_HISTORY = {
  NOT_COMPLETE: 1,
  COMPLETE: 2,
  CANCEL: 99
}

const STATUS_HISTORY_LABEL_FOR_HISTORY = {
  NOT_COMPLETE: 'order.order_unfinished',
  COMPLETE: 'order.order_complete',
  CANCEL: 'order.order_invalid'
}

export default {
  STATUS,
  STATUS_HISTORY_LABEL,
  STATUS_FOR_HISTORY,
  STATUS_HISTORY_LABEL_FOR_HISTORY
}
